function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { SHOW_MODAL, MODAL_CONFIRM, MODAL_CANCEL, HIDE_MODAL } from "../action_types/modals";
function modals_reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SHOW_MODAL:
      if (!action.modal_name) {
        console.error('modal reducer: cannot show modal with no modal name');
      }
      return Object.assign({}, state, _defineProperty({}, action.modal_name, Object.assign({}, state[action.modal_name], {
        visible: true,
        modal_state: 'open'
      })));
    case MODAL_CONFIRM:
      if (!action.modal_name) {
        console.error('modal reducer: cannot confirm modal with no modal name');
      }
      return Object.assign({}, state, _defineProperty({}, action.modal_name, Object.assign({}, state[action.modal_name], {
        modal_state: 'success',
        confirm_value: action.value
      })));
    case MODAL_CANCEL:
      if (!action.modal_name) {
        console.error('modal reducer: cannot cancel modal with no modal name');
      }
      return Object.assign({}, state, _defineProperty({}, action.modal_name, Object.assign({}, state[action.modal_name], {
        modal_state: 'cancel',
        cancel_value: action.value
      })));
    case HIDE_MODAL:
      if (!action.modal_name) {
        console.error('modal reducer: cannot hide modal with no modal name');
      }
      return Object.assign({}, state, _defineProperty({}, action.modal_name, Object.assign({}, state[action.modal_name], {
        visible: false
      })));
  }
  return state;
}
export default modals_reducer;